import { Routes } from '@angular/router';

import { PanelDemoComponent } from './panel-demo.component';

export const panelRoutes: Routes = [
  { path: 'panels', component: PanelDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/panel/panel.routes.ts